export default "__VITE_ASSET__V7stf7ij__"